import ProvidersCustomBlock from './ProvidersCustomBlock';

export default ProvidersCustomBlock;
